export default __webpack_public_path__ + "static/media/deludovico.21a4a803.jpg";